module.exports = {"CARDS":{"NEW":{"TITLE":"New cards","NO_NEW_CARDS":"There are no any new cards."},"CARD_NUMBER":"Card No","CARD_PROGRAM":"Card Program","CURRENCY":"Currency","SHORT_NUMBER":"Short Number","CARD_VALIDITY":"Card validity"}}


//////////////////
// WEBPACK FOOTER
// ./src/dashboard/app/core/translate/translations/en/cards.json
// module id = 706
// module chunks = 0